import BaseComponent  from "./base.vue";
import ShiftRoutes from "@/views/shift/routes";
import RatingRoutes from "@/views/ratings/routes";
import OfficeProfileRoutes from "@/views/office-profiles/routes";
import ContactUsRoutes from "@/views/contact-us/routes";
import DentalTempRoutes from "@/views/dental-temps/routes";
import CustomerSupportRoutes from "@/views/customer-support/routes";
import VacancyRoutes from "@/views/vacancies/routes";
import ReferRoutes from "@/views/refer/routes";
import { RouteConfig } from "vue-router";

export default [
  {
    path: "",
    name: "base",
    component: BaseComponent,
    children: [
      ...ShiftRoutes,
      ...RatingRoutes,
      ...OfficeProfileRoutes,
      ...ContactUsRoutes,
      ...DentalTempRoutes,
      ...CustomerSupportRoutes,
      ...VacancyRoutes,
      ...ReferRoutes
    ]
  }
] as RouteConfig[];
